import { reducer as formReducer } from 'redux-form'
const REDUX_FORM_CHANGE = '@@redux-form/CHANGE'

const form = formReducer.plugin({
    modelConfiguration: (state, action) => {
        switch (action.type) {
            case REDUX_FORM_CHANGE: {
                return state
            }
            default:
                return state
        }
    },
})

export default form
